import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from "@/shared/constants";
import { Egreso, EgresoParams, IEgresoPagingRes } from "@/shared/interfaces/erp/inventario";
import { useUiStore } from "@/store/ui";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { handleAxiosError } from "@/shared/utils/general";
import { getUrlParamsFetch } from "@/shared/utils";

const { get, post, put } = erpApi();

///* tanSctack query

export const useGetEgresos = (
  page = 1,
  numero_referencia = "",
  estado = "",
  fecha_before = "",
  fecha_after = ""
) => {
  return useQuery({
    queryKey: [
      "egresos",
      page,
      numero_referencia,
      estado,
      fecha_after,
      fecha_before,
    ],
    queryFn: async () => {
      let res;
      res = await get<IEgresoPagingRes>(
        `${urlBackend}api/v1/egreso-inventario/?page=${page}&numero_referencia=${numero_referencia}&estado=${estado}&fecha_creacion_before=${fecha_before}&fecha_creacion_after=${fecha_after}`,
        true
      );
      if (page > 1 && res?.status === "error") {
        res = await get<IEgresoPagingRes>(
          `${urlBackend}api/v1/egreso-inventario/`,
          true
        );
      }
      return res;
    },
  });
};

export const useGetEgreso = (id: string) => {
  return useQuery({
    queryKey: ["egresos", id],
    queryFn: async () => {
      return getEgreso(id);
    },
  });
};
export const useCreateEgresos = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = false,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createEgreso,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['egreso'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Egreso  creado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));
      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateEgresos = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updateEgreso,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Egreso'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Egreso actualizado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export type CreateEgresosParams = Omit<Egreso, "id_egreso_producto">;
export type UpdateEgresosParams = {
  id: string;
  data: CreateEgresosParams;
};

export const getEgreso = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<Egreso>(
    `${urlBackend}api/v1/egreso-inventario/${id}/`,
    true
  );

  res.status === "error" && setAlert(true, res.message, res.status);
  return res;
};

export const createEgreso = async (data: CreateEgresosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<Egreso>(
    `${urlBackend}api/v1/egreso-inventario/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};

export const updateEgreso = async ({ id, data }: UpdateEgresosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<Egreso>(
    `${urlBackend}api/v1/egreso-inventario/${id}/`,
    data,
    true
  );
  setAlert(true, res.message, res.status);
  return res;
};


export const getEgresos = async (
  params?: EgresoParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<IEgresoPagingRes>(`${urlBackend}api/v1/egreso-inventario?${queryParams}`, true);
};
